var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagWhiteColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14741 14.0003H8.90541C10.3903 14.0003 11.1329 14.0003 11.7527 13.6451C12.3725 13.29 12.7659 12.639 13.553 11.337L14.0069 10.5861C14.669 9.49079 15.0001 8.94313 15.0001 8.33366C15.0001 7.72419 14.669 7.17653 14.0069 6.08117L13.553 5.33033C12.7659 4.02835 12.3725 3.37735 11.7527 3.02217C11.1329 2.66699 10.3903 2.66699 8.90541 2.66699H7.14741C4.56382 2.66699 3.27201 2.66699 2.46937 3.49686C1.66675 4.32672 1.66675 5.66237 1.66675 8.33366C1.66675 11.0049 1.66675 12.3406 2.46937 13.1705C3.27201 14.0003 4.56381 14.0003 7.14741 14.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.33008V11.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagWhiteColor);
export default __webpack_public_path__ + "static/media/TagWhiteColor.c564111787766786b4d06aaedcb33882.svg";
export { ForwardRef as ReactComponent };